<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/establish/contractlist',title:'返利管理'},{title:'客户履约报表'}]"/>-->
      <Breadtabsheader/>
        <div class="h-content w-content">

            <!--查询表单-->
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="客户名称" prop="agentNameLike">
							    <el-input v-model="q.agentNameLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="客户编码" prop="agentCodeLike">
							    <el-input v-model="q.agentCodeLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="类型" prop="styles">
							    <el-select v-model="q.type" placeholder="请选择">
							        <el-option
							                v-for="item in fljsstyle"
							                :key="item.value"
							                :label="item.label"
							                :value="item.value">
							        </el-option>
							    </el-select>
							</el-form-item>
							<el-form-item label="产品" prop="rebateChainGroup">
								<el-select v-model="q.rebateChainGroup" placeholder="请选择">
								    <el-option
								      v-for="item in options1"
								      :key="item.code"
								      :label="item.name"
								      :value="item.code">
								    </el-option>
								  </el-select>
							</el-form-item>
						</div>
						<el-collapse-transition>
							<div v-show="isScreen">
								<div class="h-thirdColumn w-newColumn">
									<el-form-item label="区域" prop="area" >
										<el-select v-model="q.area" placeholder="请选择">
											<el-option
											  v-for="item in options2"
											  :key="item.code"
											  :label="item.name"
											  :value="item.code">
											</el-option>
										  </el-select>
									</el-form-item>
									<el-form-item label="年份" prop="year">
										<el-select filterable v-model="q.year" clearable placeholder="请选择">
											<el-option value="2020">
											</el-option>
											<el-option value="2021">
											</el-option>
											<el-option value="2022">
											</el-option>
										</el-select>
									</el-form-item>
								</div>
							</div>
						</el-collapse-transition>
                    </el-form>
					<div class="l-screenBox">
						<div class="l-screen" @click="collapseChange">
							<img :src="isScreen?closeScreen:drawScreen" alt="">
							<div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
						</div>
						<div class="l-retrieval">
							<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
							<el-button class="h-btn h-formBtn h-bgwhite" @click="qingkong">重置</el-button>
						</div>
					</div>
                </div>
            </div>



            <!--展示表格-->
            <div class="h-table h-mrt30" style="overflow-x: auto;">
                <el-table @selection-change="handleSelectionChange" :model="q"
                          ref="ddtable"
                          :data="tableData"
                          stripe
                          style="width: 100%"
                          :border="true"
                          :summary-method="getSummaries"
                          show-summary
						  max-height="530"
                >
                    <!--:summary-method="getSummaries"-->
                    <!--show-summary-->
                    <!-- <el-table-column
                            type="selection"
							width="65"
                    >
                    </el-table-column>
                    <el-table-column
                            type="index"
                            label="#"
							fixed
                            width="40">
                    </el-table-column> -->

                    <el-table-column
                            prop="customerId"
                            :show-overflow-tooltip="true"
                            label="客户编码"
                            width="120"
							fixed
                    >
                    </el-table-column>
                    <el-table-column
                            prop="customerName"
                            :show-overflow-tooltip="true"
                            label="客户名称"
                            min-width="180"
							fixed
                    >
					<template slot-scope="scope">
						<div style="text-align: left;">
							{{scope.row.customerName}}
						</div>
					</template>
                    </el-table-column>
					<el-table-column
					        prop="area"
					        :show-overflow-tooltip="true"
					        label="区域"
							width="80"
					>
					</el-table-column>
                    <el-table-column label="1月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb1"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb1).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe1"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe1).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly1"
                                :show-overflow-tooltip="true"
                                label="履约率"
								width="80"
                        >
							<template slot-scope="scope">
								<div style="text-align: right;">{{(Number(scope.row.ly1).toFixed(2)) + '%'}}</div>
							</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="2月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb2"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb2).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe2"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe2).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly2"
                                :show-overflow-tooltip="true"
                                label="履约率"
								width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly2).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="3月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb3"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb3).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe3"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe3).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly3"
                                :show-overflow-tooltip="true"
                                label="履约率"
								width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly3).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="4月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb4"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb4).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe4"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe4).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly4"
                                :show-overflow-tooltip="true"
                                label="履约率"
								width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly4).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="5月" :show-overflow-tooltip="true">
                    <el-table-column
                            prop="mb5"
                            :show-overflow-tooltip="true"
                            label="目标(万元)"
                            width="100"
                    >
					<template slot-scope="scope">
						<div style="text-align: right;">{{Number(scope.row.mb5).toFixed(2)}}</div>
					</template>
                    </el-table-column>
                    <el-table-column
                            prop="xe5"
                            :show-overflow-tooltip="true"
                            label="销额(万元)"
                            width="100"
                    >
					<template slot-scope="scope">
						<div style="text-align: right;">{{Number(scope.row.xe5).toFixed(2)}}</div>
					</template>
                    </el-table-column>
                    <el-table-column
                            prop="ly5"
                            :show-overflow-tooltip="true"
                            label="履约率"
                            width="80"
                    >
					<template slot-scope="scope">
						<div style="text-align: right;">{{(Number(scope.row.ly5).toFixed(2)) + '%'}}</div>
					</template>
                    </el-table-column>
                </el-table-column>

                    <el-table-column label="6月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb6"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb6).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe6"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe6).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly6"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly6).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="7月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb7"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb7).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe7"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe7).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly7"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly7).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="8月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb8"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb8).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe8"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe8).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly8"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly8).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="9月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb9"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb9).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe9"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe9).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly9"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly9).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="10月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb10"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb10).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe10"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe10).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly10"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly10).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="11月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb11"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb11).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe11"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe11).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly11"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly11).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>

                    <el-table-column label="12月" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="mb12"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.mb12).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="xe12"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.xe12).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="ly12"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.ly12).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>
                    <el-table-column label="全年合计" :show-overflow-tooltip="true">
                        <el-table-column
                                prop="zmb"
                                :show-overflow-tooltip="true"
                                label="目标(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.zmb).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="zxe"
                                :show-overflow-tooltip="true"
                                label="销额(万元)"
                                width="100"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{Number(scope.row.zxe).toFixed(2)}}</div>
						</template>
                        </el-table-column>
                        <el-table-column
                                prop="lyz"
                                :show-overflow-tooltip="true"
                                label="履约率"
                                width="80"
                        >
						<template slot-scope="scope">
							<div style="text-align: right;">{{(Number(scope.row.lyz).toFixed(2)) + '%'}}</div>
						</template>
                        </el-table-column>
                    </el-table-column>


                </el-table>
			</div>
			<div class="h-tableB h-mrt30">
				<div class="h-tableBL">
					<el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
							   @click="exportExcel" v-auth="'khlybb_daochu'">批量导出
					</el-button>

				</div>
				<div class="h-pagination2">
					<pagination :page="q" @query="query"/>
				</div>
			</div>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
	import big from 'big.js'

    export default {
        components: {},
        data() {
            return {
				// 展开折叠筛选
				isScreen:false,
				closeScreen:require("@/assets/images/pimg/closeallic.png"),
				drawScreen:require("@/assets/images/pimg/dobleArr.png"),
                fljsstyle: [
                    {
                        value: 1,
                        label: '年累计'
                    },
                    {
                        value: 2,
                        label: '月累计'
                    },
                ],

                value2:'',
                showhistory:false,
                instid: '',
                taskid:'',
                //查询属性
                page:{
                    contractBaseId:'',
                    pageSize:20,
                    pageNo:1
                },
                q: {
                    styles: '',
                    taskid:'',
                    rebateChainGroup:null,
                    agentNameLike:'',
                    agentCodeLike:'',
                    type:null,
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                },
                //表单
                f:{
                    pageNo:1,
                    id:null, //
                    agentName:null, //
                    agentCode:null, //
                    area:null,
                    ymmb:null,
                    ymxe:null, //
                    ymly:null, //
                    xymb:null, //
                    xyxe:null,
                    xyly:null,
                    sjmb:null, //
                    sjxe:null, //
                    sjly:null, //
                    ctmb:null,
                    ctxe:null,
                    ctly:null, //
                    zmb:null, //
                    zxe:null, //
                    zly:null,


                },
                //表格
                multipleSelection: [],
                countlist:[],

                //table列表
                tableData: [],
                flag:0,
                //操作标志
                optflag:'save',
				options1:[],
				options2:[]

            }
        },
        created() {
            this.queryb();
            this.q = {
                styles: '',
                taskid:'',
                agentNameLike:'',
                agentCodeLike:'',
                pageSize: 10,
                pageNo: 1,
                total: 0,
                rebateChainGroup:'zhj',
                type:2,
				year:'2022'
            }
            this.query();
            this.querya();

        },
        methods: {
			// 展开折叠
			collapseChange(){
				this.isScreen = !this.isScreen;
			},

            //重置
            qingkong(){
                this.qijianLike=null,
                // this.q.fljsstyle='2';
                // this.q.rebateChainGroup='zhj';
                //     this.q={
                //         pageSize: 10,
                //         pageNo: 1,
                //         total: 0,
                //     }
                    this.q = {
                        styles: '',
                        taskid:'',
                        agentNameLike:'',
                        agentCodeLike:'',
                        pageSize: 10,
                        pageNo: 1,
                        total: 0,
                        rebateChainGroup:'zhj',
                        type:2,
                    }
                    this.query();
                this.querya()
            },
            querya() {
                ss.fanli.pageCustomerLyZongjiTable(this.q).then(rd=>{
                    console.log(rd.records,"AAAABBBBBB");
                    this.countlist = rd.records;
                });

            },
            queryb() {
                ss.fanli.pageQuanxian(this.q).then(rd=>{
                    console.log(rd,"AAAABBBBBB");
					this.options1 = rd.list;
					this.options2 = rd.list1;
                });

            },

            query() {
                //console.log(this.q,"/././././././")
                ss.fanli.pageCustomerLyTable(this.q).then(rd=>{
                    // console.log(rd,"BBBBBB");
                    this.q.total = rd.total;
					var rds = rd.records;
					for(var i=0;i<rds.length;i++){
						 rds[i].ly1 = (rds[i].ly1).slice(0,(rds[i].ly1).length-1)
						 rds[i].ly2 = (rds[i].ly2).slice(0,(rds[i].ly2).length-1)
						 rds[i].ly3 = (rds[i].ly3).slice(0,(rds[i].ly3).length-1)
						 rds[i].ly4 = (rds[i].ly4).slice(0,(rds[i].ly4).length-1)
						 rds[i].ly5 = (rds[i].ly5).slice(0,(rds[i].ly5).length-1)
						 rds[i].ly6 = (rds[i].ly6).slice(0,(rds[i].ly6).length-1)
						 rds[i].ly7 = (rds[i].ly7).slice(0,(rds[i].ly7).length-1)
						 rds[i].ly8 = (rds[i].ly8).slice(0,(rds[i].ly8).length-1)
						 rds[i].ly9 = (rds[i].ly9).slice(0,(rds[i].ly9).length-1)
						 rds[i].ly10 = (rds[i].ly10).slice(0,(rds[i].ly10).length-1)
						 rds[i].ly11 = (rds[i].ly11).slice(0,(rds[i].ly11).length-1)
						 rds[i].ly12 = (rds[i].ly12).slice(0,(rds[i].ly12).length-1)
						 rds[i].lyz = (rds[i].lyz).slice(0,(rds[i].lyz).length-1)
					}
                    this.tableData = rds;
                });

            },
            // getSummaries(param){
            //     const { columns, data } = param;
            //     const sums = [];
            //     columns.forEach((column, index) => {
            //         console.log(column,index)
            //         if (index === 0) {
            //             sums[index] = '总计';
            //             return;
            //         }
            //         const values = data.map(item => Number(item[column.property]));
            //         if (!values.every(value => isNaN(value))) {
            //             sums[index] = values.reduce((prev, curr) => {
            //                 const value = Number(curr);
            //                 if (!isNaN(value)) {
            //                     return prev + curr;
            //                 } else {
            //                     return prev;
            //                 }
            //             }, 0);
            //             sums[1] = '';
            //             sums[2] = '';
            //             sums[3] = '';
            //             sums[4] = '';
            //
            //         } else {
            //             sums[index] = '0';
            //             sums[7]= (sums[6]/ sums[5]*100).toFixed(2)+"%";
            //             sums[10]= (sums[9]/ sums[8]*100).toFixed(2)+"%";
            //             sums[13]= (sums[12]/ sums[11]*100).toFixed(2)+"%";
            //             sums[16]= (sums[15]/ sums[14]*100).toFixed(2)+"%";
            //             sums[19]= (sums[18]/ sums[17]*100).toFixed(2)+"%";
            //
            //         }
            //     });
            //
            //     return sums;
            // },
            handleFilter() {
                // console.log("QQQQQ")
                this.query();
                this.querya()
            },
            //勾选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                // console.log(this.multipleSelection,"WWWWWWWWWW")
            },
            // //批量导出
            // exportExcel() {
            //     var idlist = [];
            //     this.multipleSelection.forEach(element => {
            //         idlist.push(element.id);
            //     });
            //     console.log(idlist,"AAAAAQQqq")
            //     updownfile.down("/api/swyl/v1/fanli/hetong/flContractAgent/downcustomerLyTableExcel", idlist, "post", 'data');
            // },

            //开票明细批量导出
            exportExcel() {
                var idlist = [];
                this.multipleSelection.forEach(element => {
                    // console.log(this.q.type+"@@@@@@@@");
                    // idlist.push(
                    //     {
                    //         id: element.id+","+this.q.type+","+this.q.rebateChainGroup,
                    //     }
                    // );
                    idlist.push(element.customerId+","+this.q.type+","+this.q.rebateChainGroup);
                    // console.log(idlist);
                });
                if (idlist.length != 0) {
                    console.log(idlist);
                    updownfile.down("/api/swyl/v1/demo/viewLvyueTable/downloadExcelIdDetail", idlist, "post", 'data');
                } else {
                    updownfile.down("/api/swyl/v1/demo/viewLvyueTable/downloadExcelEntity", this.q, "post");
                }

            },
            getSummaries(param){
                const { columns, data } = param;
                const sums = [];
                columns.forEach((column, index) => {
                    console.log(column,index)
                    if (index === 0) {
                        sums[index] = '总计';
                        console.log(index+"@@@@@@")
                        return;
                    }
                    const values = data.map(item => Number(item[column.property]));
                    if (!values.every(value => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr);
                            if (!isNaN(value)) {
                                return prev + curr;
                            } else {
                                return prev;
                            }
                        }, 0);
                        console.log((this.countlist[0].ly1).slice(0,(this.countlist[0].ly1).length-1),"/./././.")
                        // sums[5] = Number(this.countlist[0].mb1).toFixed(2);
                        // sums[6] = Number(this.countlist[0].xe1).toFixed(2);
                        // sums[7] = Number((this.countlist[0].ly1).slice(0,(this.countlist[0].ly1).length-1)).toFixed(2) + '%';
                        // sums[8] = Number(this.countlist[0].mb2).toFixed(2);
                        // sums[9] = Number(this.countlist[0].xe2).toFixed(2);
                        // sums[10] = Number((this.countlist[0].ly2).slice(0,(this.countlist[0].ly2).length-1)).toFixed(2) + '%';
                        // sums[11] = Number(this.countlist[0].mb3).toFixed(2);
                        // sums[12] = Number(this.countlist[0].xe3).toFixed(2);
                        // sums[13] = Number((this.countlist[0].ly3).slice(0,(this.countlist[0].ly3).length-1)).toFixed(2) + '%';
                        // sums[14] = Number(this.countlist[0].mb4).toFixed(2);
                        // sums[15] = Number(this.countlist[0].xe4).toFixed(2);
                        // sums[16] = Number((this.countlist[0].ly4).slice(0,(this.countlist[0].ly4).length-1)).toFixed(2) + '%';
                        // sums[17] = Number(this.countlist[0].mb5).toFixed(2);
                        // sums[18] = Number(this.countlist[0].xe5).toFixed(2);
                        // sums[19] = Number((this.countlist[0].ly5).slice(0,(this.countlist[0].ly5).length-1)).toFixed(2) + '%';
                        // sums[20] = Number(this.countlist[0].mb6).toFixed(2);
                        // sums[21] = Number(this.countlist[0].xe6).toFixed(2);
                        // sums[22] = Number((this.countlist[0].ly6).slice(0,(this.countlist[0].ly6).length-1)).toFixed(2) + '%';
                        // sums[23] = Number(this.countlist[0].mb7).toFixed(2);
                        // sums[24] = Number(this.countlist[0].xe7).toFixed(2);
                        // sums[25] = Number((this.countlist[0].ly7).slice(0,(this.countlist[0].ly7).length-1)).toFixed(2) + '%';
                        // sums[26] = Number(this.countlist[0].mb8).toFixed(2);
                        // sums[27] = Number(this.countlist[0].xe8).toFixed(2);
                        // sums[28] = Number((this.countlist[0].ly8).slice(0,(this.countlist[0].ly8).length-1)).toFixed(2) + '%';
                        // sums[29] = Number(this.countlist[0].mb9).toFixed(2);
                        // sums[30] = Number(this.countlist[0].xe9).toFixed(2);
                        // sums[31] = Number((this.countlist[0].ly9).slice(0,(this.countlist[0].ly9).length-1)).toFixed(2) + '%';
                        // sums[32] = Number(this.countlist[0].mb10).toFixed(2);
                        // sums[33] = Number(this.countlist[0].xe10).toFixed(2);
                        // sums[34] = Number((this.countlist[0].ly10).slice(0,(this.countlist[0].ly10).length-1)).toFixed(2) + '%';
                        // sums[35] = Number(this.countlist[0].mb11).toFixed(2);
                        // sums[36] = Number(this.countlist[0].xe11).toFixed(2);
                        // sums[37] = Number((this.countlist[0].ly11).slice(0,(this.countlist[0].ly11).length-1)).toFixed(2) + '%';
                        // sums[38] = Number(this.countlist[0].mb12).toFixed(2);
                        // sums[39] = Number(this.countlist[0].xe12).toFixed(2);
                        // sums[40] = Number((this.countlist[0].ly12).slice(0,(this.countlist[0].ly12).length-1)).toFixed(2) + '%';
                        // sums[41] = Number(this.countlist[0].zmb).toFixed(2);
                        // sums[42] = Number(this.countlist[0].zxe).toFixed(2);
                        // sums[43] = Number((this.countlist[0].lyz).slice(0,(this.countlist[0].lyz).length-1)).toFixed(2) + '%';

						sums[3] = Number(this.countlist[0].mb1).toFixed(2);
						sums[4] = Number(this.countlist[0].xe1).toFixed(2);
						sums[5] = Number((this.countlist[0].ly1).slice(0,(this.countlist[0].ly1).length-1)).toFixed(2) + '%';
						sums[6] = Number(this.countlist[0].mb2).toFixed(2);
						sums[7] = Number(this.countlist[0].xe2).toFixed(2);
						sums[8] = Number((this.countlist[0].ly2).slice(0,(this.countlist[0].ly2).length-1)).toFixed(2) + '%';
						sums[9] = Number(this.countlist[0].mb3).toFixed(2);
						sums[10] = Number(this.countlist[0].xe3).toFixed(2);
						sums[11] = Number((this.countlist[0].ly3).slice(0,(this.countlist[0].ly3).length-1)).toFixed(2) + '%';
						sums[12] = Number(this.countlist[0].mb4).toFixed(2);
						sums[13] = Number(this.countlist[0].xe4).toFixed(2);
						sums[14] = Number((this.countlist[0].ly4).slice(0,(this.countlist[0].ly4).length-1)).toFixed(2) + '%';
						sums[15] = Number(this.countlist[0].mb5).toFixed(2);
						sums[16] = Number(this.countlist[0].xe5).toFixed(2);
						sums[17] = Number((this.countlist[0].ly5).slice(0,(this.countlist[0].ly5).length-1)).toFixed(2) + '%';
						sums[18] = Number(this.countlist[0].mb6).toFixed(2);
						sums[19] = Number(this.countlist[0].xe6).toFixed(2);
						sums[20] = Number((this.countlist[0].ly6).slice(0,(this.countlist[0].ly6).length-1)).toFixed(2) + '%';
						sums[21] = Number(this.countlist[0].mb7).toFixed(2);
						sums[22] = Number(this.countlist[0].xe7).toFixed(2);
						sums[23] = Number((this.countlist[0].ly7).slice(0,(this.countlist[0].ly7).length-1)).toFixed(2) + '%';
						sums[24] = Number(this.countlist[0].mb8).toFixed(2);
						sums[25] = Number(this.countlist[0].xe8).toFixed(2);
						sums[26] = Number((this.countlist[0].ly8).slice(0,(this.countlist[0].ly8).length-1)).toFixed(2) + '%';
						sums[27] = Number(this.countlist[0].mb9).toFixed(2);
						sums[28] = Number(this.countlist[0].xe9).toFixed(2);
						sums[29] = Number((this.countlist[0].ly9).slice(0,(this.countlist[0].ly9).length-1)).toFixed(2) + '%';
						sums[30] = Number(this.countlist[0].mb10).toFixed(2);
						sums[31] = Number(this.countlist[0].xe10).toFixed(2);
						sums[32] = Number((this.countlist[0].ly10).slice(0,(this.countlist[0].ly10).length-1)).toFixed(2) + '%';
						sums[33] = Number(this.countlist[0].mb11).toFixed(2);
						sums[34] = Number(this.countlist[0].xe11).toFixed(2);
						sums[35] = Number((this.countlist[0].ly11).slice(0,(this.countlist[0].ly11).length-1)).toFixed(2) + '%';
						sums[36] = Number(this.countlist[0].mb12).toFixed(2);
						sums[37] = Number(this.countlist[0].xe12).toFixed(2);
						sums[38] = Number((this.countlist[0].ly12).slice(0,(this.countlist[0].ly12).length-1)).toFixed(2) + '%';
						sums[39] = Number(this.countlist[0].zmb).toFixed(2);
						sums[40] = Number(this.countlist[0].zxe).toFixed(2);
						sums[41] = Number((this.countlist[0].lyz).slice(0,(this.countlist[0].lyz).length-1)).toFixed(2) + '%';
                    } else {
                        sums[1] = '';
                        sums[2] = '';

						// sums[3] = '';
						// sums[4] = '';
                    }
                });

                return sums;
            },

        }
    }
</script>
<style lang="scss">
    .el-table thead.is-group th{
        background-color: #57aefe;
    }
	.w-content .el-table__footer-wrapper .cell {
		text-align: right;
	}
	/*table一条合计行滚动条样式*/
	/* .el-table{
	    overflow: auto;
	}
	.el-table .el-table__body-wrapper,
	.el-table .el-table__header-wrapper,
	.el-table .el-table__footer-wrapper{
	    overflow: visible;
	}
	.el-table::after{
	    position:relative !important;
	} */
	.w-content .el-table__fixed-footer-wrapper tbody td {
		background: #cce7ff;
	}
	.w-content .el-table__footer-wrapper tbody td {
		background: #cce7ff;
	}
	.el-table--scrollable-x .el-table__body-wrapper {
	    z-index : 1;
	}
	.el-table__fixed, .el-table__fixed-right {
	    box-shadow: none;
	}
	.el-table__fixed, .el-table__fixed-right {
	      &::after{
	         position:absolute;
	         top:0;
	         right:0;
	         bottom:0;
	         content:'';
	         z-index:100;
	         box-shadow: 0 0 10px rgba(0,0,0,.12);
	      }
	    }
	.el-table__fixed-footer-wrapper tbody td{
		border-top: 0;
	}
</style>
